import React from 'react';
import "./ContactBanner.css"

const ContactBanner = () => {
    return (
        <div className='contact-banner '>
            <div className='contact-overlay'></div>
            <div className='contact-div'>
                <h1>Nous Contacter</h1>
                {/* <p>Home Page <span className='mx-2'>{">"}</span>Contact Us</p> */}
            </div>
        </div>
    );
};

export default ContactBanner;